import { styled } from '../../../shared/theming-sc/'

import { switchVisibility, textOverflowEllipsis } from '../../../shared/utilities/styleUtils'

export const StyledTextInput = styled.div.attrs({
  style: switchVisibility
})`
  position: absolute; left:0; top:0;
  padding: 22px 20px;
  width: 100%;
  height: 100%;
`

const inputLeft = 20
const inputWidth = `calc(100% - ${inputLeft}px)`

export const StyledInput = styled.input`
  position: absolute; 
  top:0;
  left: ${inputLeft}px;
  height: 100%;
  width: ${inputWidth};
  outline: none;
  color: inherit;
  font-size: inherit;
  font-family: inherit;
  border: none;
  background: transparent;
  &::-ms-clear {
    display: none
  }
`
export const StyledPlaceholder = styled.div.attrs({
  style: switchVisibility
})`
  color: #afafaf;
  width: 100%;
  ${textOverflowEllipsis}
`
